import imageUrlBuilder from "@sanity/image-url";
import React from "react";

import { Text } from "@/components/elements/Text";
import styles from "@/components/LandingPage/styles.module.css";
import SubcategoriesGrid from "@/components/SubcategoriesGrid";
import { client } from "@/sanity/lib/client";

import { Article, ExplorePafyllSectionProps } from "./types";

export const ExplorePafyllSection = ({
  title,
  articles,
}: ExplorePafyllSectionProps) => {
  // Sanity image builder
  const builder = imageUrlBuilder(client());
  function urlFor(source) {
    return builder.image(source);
  }

  return (
    <section className={styles.explorpafyllSection}>
      <Text
        as="h2"
        size="l"
        responsive
        className={styles.discoverProductsTitle}
      >
        {title}
      </Text>
      <SubcategoriesGrid>
        {articles.map((article: Article) => (
          <SubcategoriesGrid.Card
            className={styles.explorpafyllGridCard}
            key={article.link}
            as="li"
            imgSrc={urlFor(article.image).url()}
            slug={article.link}
            text={article.title}
            subtitle={article.category}
          />
        ))}
      </SubcategoriesGrid>
    </section>
  );
};
